<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="flex justify-center px-4">
      <div class="relative flex flex-col items-start rounded bg-white p-6">
        <img
          class="absolute right-4 top-4 h-4 w-4"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />

        <h3 class="mb-4 text-2xl text-dark-blue">Contact Us</h3>
        <p class="mb-4 text-left text-1md text-body-color">
          Send us a message in the box below and tell us how we can help you.
        </p>
        <div class="mb-4 w-full">
          <div class="flex items-center">
            <p class="mb-1 text-2xs font-bold uppercase text-dark-blue">
              How can we help?
            </p>
          </div>
          <textarea
            v-model="message"
            placeholder="Describe the issue in as much detail as possible."
            class="mb-2 h-20 w-full rounded-md border border-transparent bg-off-white p-2 px-3 text-1md text-dark-gray placeholder-gray-over-dark hover:border-placeholder-gray focus:bg-white"
            name="message"
            @input="handleChange"
          />
          <div class="flex flex-col md:flex-row-reverse md:gap-4">
            <button-main
              :disabled="!message || message.length < 5"
              class="text-1md"
              @click="() => sendMessage(message)"
            >
              Submit
            </button-main>
            <button-main
              class="mt-2 text-1md md:mt-0 lg:text-base"
              variant="secondary"
              @click="$emit('close')"
            >
              Cancel
            </button-main>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'ContactUsModal',
  components: {
    Modal,
    ButtonMain,
  },
  props: {
    visible: Boolean,
  },
  emits: ['close'],
  data() {
    return {
      message: '',
    };
  },
  methods: {
    async sendMessage(message) {
      console.log(message);
      // TODO  - Call the API endpoint
      this.$emit('close');
    },
  },
};
</script>
